/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/api.proto
 * OpenAPI spec version: version not set
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  AutomationServiceActivateAutomationBody,
  AutomationServiceAddAutomationConnectionsBody,
  AutomationServiceBatchTraceCollectionUsageBody,
  AutomationServiceBulkUpgradeAutomationBookConnectionsBody,
  AutomationServiceCountConnectionUsageBody,
  AutomationServiceDeactivateAutomationBody,
  AutomationServiceDisableAutomationScheduleBody,
  AutomationServiceDuplicateAutomationBody,
  AutomationServiceEnableAutomationScheduleBody,
  AutomationServiceForkPublishedAutomationBody,
  AutomationServiceGenerateAutomationVisualizationBody,
  AutomationServiceInvokeAutomationBody,
  AutomationServicePreviewAutomationScheduleBody,
  AutomationServicePromoteParamsToCodeBody,
  AutomationServicePublishAutomationBody,
  AutomationServiceRemoveAutomationConnectionsBody,
  AutomationServiceRenameAutomationBody,
  AutomationServiceRestoreAutomationBody,
  AutomationServiceSetAutomationDefaultInputsBody,
  AutomationServiceSetAutomationLabelsBody,
  AutomationServiceSwitchAutomationConnectionsBody,
  AutomationServiceTraceConnectionUsageBody,
  AutomationServiceTuneStepConfigBody,
  AutomationServiceUndeleteAutomationBody,
  AutomationServiceUpgradeAutomationBookConnectionVersionBody,
  AutomationServiceUpgradeAutomationConnectionsBody,
  AutomationServiceValidateAutomationPublishBody,
  BatchGetAutomationNamesParams,
  BuildStepHarnessParams,
  DeleteAutomationParams,
  DeleteAutomationSchedule200,
  DeleteDraftAutomation200,
  DeleteDraftAutomationParams,
  DeleteWorkspaceConnectionParams,
  ExtractAutomationCodeConnectionsParams,
  GetAutomationParams,
  IdentifyStepValueSlotsParams,
  InspectStepConfigParams,
  ListAutomationRevisionSummariesParams,
  ListAutomationRevisionsParams,
  ListAutomationSummariesParams,
  ListAutomationsParams,
  ListDefaultInputsHistoryParams,
  QueryAutomationParams,
  RpcStatus,
  UpdateAutomationBody,
  UpdateAutomationScheduleBody,
  V1ActivateAutomationResponse,
  V1AddAutomationConnectionsResponse,
  V1Automation,
  V1AutomationRevision,
  V1AutomationSchedule,
  V1AutomationVisualization,
  V1BatchGetAutomationNamesResponse,
  V1BatchTraceCollectionUsageResponse,
  V1BuildStepHarnessResponse,
  V1BulkUpgradeAutomationBookConnectionsResponse,
  V1CountConnectionUsageResponse,
  V1DeactivateAutomationResponse,
  V1DeleteWorkspaceConnectionResponse,
  V1DisableAutomationScheduleResponse,
  V1DuplicateAutomationResponse,
  V1EnableAutomationScheduleResponse,
  V1ExtractAutomationCodeConnectionsResponse,
  V1ForkPublishedAutomationResponse,
  V1GenerateAutomationVisualizationResponse,
  V1GetNextCopyNameResponse,
  V1IdentifyStepValueSlotsResponse,
  V1InspectStepConfigResponse,
  V1InvokeAutomationResponse,
  V1InvokeScheduledAutomationRequest,
  V1InvokeScheduledAutomationResponse,
  V1ListAutomationRevisionSummariesResponse,
  V1ListAutomationRevisionsResponse,
  V1ListAutomationSummariesResponse,
  V1ListAutomationsResponse,
  V1ListDefaultInputsHistoryResponse,
  V1MigrateConnectionAliasesRequest,
  V1MigrateConnectionAliasesResponse,
  V1PreviewAutomationScheduleResponse,
  V1PromoteParamsToCodeResponse,
  V1PublishAutomationResponse,
  V1RemoveAutomationConnectionsResponse,
  V1RestoreAutomationResponse,
  V1SwitchAutomationConnectionsResponse,
  V1TraceAssetUsageResponse,
  V1TraceCollectionUsageResponse,
  V1TraceConnectionUsageResponse,
  V1TuneStepConfigResponse,
  V1UpgradeAutomationBookConnectionVersionResponse,
  V1UpgradeAutomationConnectionsResponse,
  V1ValidateAutomationPublishResponse,
} from '../models';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

/**
 * @summary TraceAssetUsage returns all automations that reference a specific asset (file).
Assets are read-only references, so no usage type is reported. An asset id is the
underlying Bishop file id.
Per AIP-136, this is a custom method using the :traceAssetUsage suffix.
 */
export const traceAssetUsage = (
  organization: string,
  workspace: string,
  asset: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1TraceAssetUsageResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets/${asset}:traceAssetUsage`,
    options,
  );
};

export const getTraceAssetUsageQueryKey = (
  organization?: string,
  workspace?: string,
  asset?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/assets/${asset}:traceAssetUsage`,
  ] as const;
};

export const getTraceAssetUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof traceAssetUsage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  asset: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof traceAssetUsage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTraceAssetUsageQueryKey(organization, workspace, asset);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof traceAssetUsage>>> = ({
    signal,
  }) =>
    traceAssetUsage(organization, workspace, asset, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && asset),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof traceAssetUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraceAssetUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof traceAssetUsage>>
>;
export type TraceAssetUsageQueryError = AxiosError<RpcStatus>;

export function useTraceAssetUsage<
  TData = Awaited<ReturnType<typeof traceAssetUsage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  asset: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof traceAssetUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof traceAssetUsage>>,
          TError,
          Awaited<ReturnType<typeof traceAssetUsage>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTraceAssetUsage<
  TData = Awaited<ReturnType<typeof traceAssetUsage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  asset: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof traceAssetUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof traceAssetUsage>>,
          TError,
          Awaited<ReturnType<typeof traceAssetUsage>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTraceAssetUsage<
  TData = Awaited<ReturnType<typeof traceAssetUsage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  asset: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof traceAssetUsage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary TraceAssetUsage returns all automations that reference a specific asset (file).
Assets are read-only references, so no usage type is reported. An asset id is the
underlying Bishop file id.
Per AIP-136, this is a custom method using the :traceAssetUsage suffix.
 */

export function useTraceAssetUsage<
  TData = Awaited<ReturnType<typeof traceAssetUsage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  asset: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof traceAssetUsage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTraceAssetUsageQueryOptions(
    organization,
    workspace,
    asset,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary ListAutomations returns a paginated list of automations accessible to the caller.
Supports pagination through page_size and page_token parameters.
 */
export const listAutomations = (
  organization: string,
  workspace: string,
  params?: ListAutomationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAutomationsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListAutomationsInfiniteQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListAutomationsParams,
) => {
  return [
    'infinite',
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAutomationsQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListAutomationsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAutomationsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAutomations>>,
    ListAutomationsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAutomations>>,
        TError,
        TData,
        QueryKey,
        ListAutomationsParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAutomationsInfiniteQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAutomations>>,
    QueryKey,
    ListAutomationsParams['page_token']
  > = ({ signal, pageParam }) =>
    listAutomations(
      organization,
      workspace,
      { ...params, page_token: pageParam || params?.['page_token'] },
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAutomations>>,
    TError,
    TData,
    QueryKey,
    ListAutomationsParams['page_token']
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAutomationsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAutomations>>
>;
export type ListAutomationsInfiniteQueryError = AxiosError<RpcStatus>;

export function useListAutomationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAutomations>>,
    ListAutomationsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListAutomationsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAutomations>>,
        TError,
        TData,
        QueryKey,
        ListAutomationsParams['page_token']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomations>>,
          TError,
          Awaited<ReturnType<typeof listAutomations>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAutomations>>,
    ListAutomationsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAutomations>>,
        TError,
        TData,
        QueryKey,
        ListAutomationsParams['page_token']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomations>>,
          TError,
          Awaited<ReturnType<typeof listAutomations>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAutomations>>,
    ListAutomationsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAutomations>>,
        TError,
        TData,
        QueryKey,
        ListAutomationsParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ListAutomations returns a paginated list of automations accessible to the caller.
Supports pagination through page_size and page_token parameters.
 */

export function useListAutomationsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAutomations>>,
    ListAutomationsParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAutomations>>,
        TError,
        TData,
        QueryKey,
        ListAutomationsParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAutomationsInfiniteQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListAutomationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAutomations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAutomationsQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAutomations>>> = ({
    signal,
  }) =>
    listAutomations(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAutomations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAutomationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAutomations>>
>;
export type ListAutomationsQueryError = AxiosError<RpcStatus>;

export function useListAutomations<
  TData = Awaited<ReturnType<typeof listAutomations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListAutomationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomations>>,
          TError,
          Awaited<ReturnType<typeof listAutomations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomations<
  TData = Awaited<ReturnType<typeof listAutomations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomations>>,
          TError,
          Awaited<ReturnType<typeof listAutomations>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomations<
  TData = Awaited<ReturnType<typeof listAutomations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ListAutomations returns a paginated list of automations accessible to the caller.
Supports pagination through page_size and page_token parameters.
 */

export function useListAutomations<
  TData = Awaited<ReturnType<typeof listAutomations>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomations>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAutomationsQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary CreateAutomation creates a new automation with the provided name, code, and dependencies.
The created automation will have type DRAFT and can be updated before being published.
Returns the created automation with a unique ID and metadata.
 */
export const createAutomation = (
  organization: string,
  workspace: string,
  v1Automation: NonReadonly<V1Automation>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Automation>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations`,
    v1Automation,
    options,
  );
};

export const getCreateAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: NonReadonly<V1Automation>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAutomation>>,
  TError,
  { organization: string; workspace: string; data: NonReadonly<V1Automation> },
  TContext
> => {
  const mutationKey = ['createAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAutomation>>,
    { organization: string; workspace: string; data: NonReadonly<V1Automation> }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return createAutomation(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAutomation>>
>;
export type CreateAutomationMutationBody = NonReadonly<V1Automation>;
export type CreateAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary CreateAutomation creates a new automation with the provided name, code, and dependencies.
The created automation will have type DRAFT and can be updated before being published.
Returns the created automation with a unique ID and metadata.
 */
export const useCreateAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: NonReadonly<V1Automation>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAutomation>>,
  TError,
  { organization: string; workspace: string; data: NonReadonly<V1Automation> },
  TContext
> => {
  const mutationOptions = getCreateAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary GetAutomation retrieves a specific automation by its unique ID.
Returns the complete automation definition including code, artifacts, and dependencies.
By default, returns the latest version of the automation.
 */
export const getAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  params?: GetAutomationParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Automation>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetAutomationQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: GetAutomationParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAutomationQueryOptions = <
  TData = Awaited<ReturnType<typeof getAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: GetAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAutomation>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAutomationQueryKey(organization, workspace, automation, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAutomation>>> = ({
    signal,
  }) =>
    getAutomation(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAutomation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAutomationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAutomation>>
>;
export type GetAutomationQueryError = AxiosError<RpcStatus>;

export function useGetAutomation<
  TData = Awaited<ReturnType<typeof getAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: undefined | GetAutomationParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAutomation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutomation>>,
          TError,
          Awaited<ReturnType<typeof getAutomation>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAutomation<
  TData = Awaited<ReturnType<typeof getAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: GetAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAutomation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutomation>>,
          TError,
          Awaited<ReturnType<typeof getAutomation>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAutomation<
  TData = Awaited<ReturnType<typeof getAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: GetAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAutomation>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary GetAutomation retrieves a specific automation by its unique ID.
Returns the complete automation definition including code, artifacts, and dependencies.
By default, returns the latest version of the automation.
 */

export function useGetAutomation<
  TData = Awaited<ReturnType<typeof getAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: GetAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAutomation>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAutomationQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary DeleteAutomation soft deletes an automation from the system. The automation is purged sometime after
it has been deleted.
 */
export const deleteAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  params?: DeleteAutomationParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Automation>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      params?: DeleteAutomationParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    params?: DeleteAutomationParams;
  },
  TContext
> => {
  const mutationKey = ['deleteAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      params?: DeleteAutomationParams;
    }
  > = props => {
    const { organization, workspace, automation, params } = props ?? {};

    return deleteAutomation(
      organization,
      workspace,
      automation,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAutomation>>
>;

export type DeleteAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary DeleteAutomation soft deletes an automation from the system. The automation is purged sometime after
it has been deleted.
 */
export const useDeleteAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        params?: DeleteAutomationParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    params?: DeleteAutomationParams;
  },
  TContext
> => {
  const mutationOptions = getDeleteAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary UpdateAutomation modifies an existing automation with new code, artifacts, or dependencies.
 */
export const updateAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  updateAutomationBody: NonReadonly<UpdateAutomationBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Automation>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}`,
    updateAutomationBody,
    options,
  );
};

export const getUpdateAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: NonReadonly<UpdateAutomationBody>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: NonReadonly<UpdateAutomationBody>;
  },
  TContext
> => {
  const mutationKey = ['updateAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: NonReadonly<UpdateAutomationBody>;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return updateAutomation(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAutomation>>
>;
export type UpdateAutomationMutationBody = NonReadonly<UpdateAutomationBody>;
export type UpdateAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary UpdateAutomation modifies an existing automation with new code, artifacts, or dependencies.
 */
export const useUpdateAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: NonReadonly<UpdateAutomationBody>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: NonReadonly<UpdateAutomationBody>;
  },
  TContext
> => {
  const mutationOptions = getUpdateAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary DeleteDraftAutomation deletes draft versions of an automation.
This endpoint specifically targets draft automations and will fail if the automation is not in DRAFT state.
 */
export const deleteDraftAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  params?: DeleteDraftAutomationParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteDraftAutomation200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/drafts`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteDraftAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDraftAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      params?: DeleteDraftAutomationParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDraftAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    params?: DeleteDraftAutomationParams;
  },
  TContext
> => {
  const mutationKey = ['deleteDraftAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDraftAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      params?: DeleteDraftAutomationParams;
    }
  > = props => {
    const { organization, workspace, automation, params } = props ?? {};

    return deleteDraftAutomation(
      organization,
      workspace,
      automation,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDraftAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDraftAutomation>>
>;

export type DeleteDraftAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary DeleteDraftAutomation deletes draft versions of an automation.
This endpoint specifically targets draft automations and will fail if the automation is not in DRAFT state.
 */
export const useDeleteDraftAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteDraftAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        params?: DeleteDraftAutomationParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDraftAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    params?: DeleteDraftAutomationParams;
  },
  TContext
> => {
  const mutationOptions = getDeleteDraftAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary PromoteParamsToCode writes tuned params back into the automation's draft SPy
source at their value-slot locations (inline literal or a constant's
definition), committing a new draft version. The adopt-the-winner step.
Per AIP-136, a custom method (:promoteParamsToCode).
 */
export const promoteParamsToCode = (
  organization: string,
  workspace: string,
  automation: string,
  automationServicePromoteParamsToCodeBody: AutomationServicePromoteParamsToCodeBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PromoteParamsToCodeResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/promotedParams`,
    automationServicePromoteParamsToCodeBody,
    options,
  );
};

export const getPromoteParamsToCodeMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteParamsToCode>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServicePromoteParamsToCodeBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoteParamsToCode>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServicePromoteParamsToCodeBody;
  },
  TContext
> => {
  const mutationKey = ['promoteParamsToCode'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoteParamsToCode>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServicePromoteParamsToCodeBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return promoteParamsToCode(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoteParamsToCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoteParamsToCode>>
>;
export type PromoteParamsToCodeMutationBody =
  AutomationServicePromoteParamsToCodeBody;
export type PromoteParamsToCodeMutationError = AxiosError<RpcStatus>;

/**
 * @summary PromoteParamsToCode writes tuned params back into the automation's draft SPy
source at their value-slot locations (inline literal or a constant's
definition), committing a new draft version. The adopt-the-winner step.
Per AIP-136, a custom method (:promoteParamsToCode).
 */
export const usePromoteParamsToCode = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof promoteParamsToCode>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServicePromoteParamsToCodeBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof promoteParamsToCode>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServicePromoteParamsToCodeBody;
  },
  TContext
> => {
  const mutationOptions = getPromoteParamsToCodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ListAutomationRevisions returns a paginated list of revisions for a specific automation.
Revisions are returned in reverse chronological order (newest first) by default.
 */
export const listAutomationRevisions = (
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationRevisionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAutomationRevisionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/revisions`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListAutomationRevisionsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: ListAutomationRevisionsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/revisions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAutomationRevisionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAutomationRevisions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationRevisionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationRevisions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAutomationRevisionsQueryKey(
      organization,
      workspace,
      automation,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAutomationRevisions>>
  > = ({ signal }) =>
    listAutomationRevisions(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAutomationRevisions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAutomationRevisionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAutomationRevisions>>
>;
export type ListAutomationRevisionsQueryError = AxiosError<RpcStatus>;

export function useListAutomationRevisions<
  TData = Awaited<ReturnType<typeof listAutomationRevisions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: undefined | ListAutomationRevisionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationRevisions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomationRevisions>>,
          TError,
          Awaited<ReturnType<typeof listAutomationRevisions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationRevisions<
  TData = Awaited<ReturnType<typeof listAutomationRevisions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationRevisionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationRevisions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomationRevisions>>,
          TError,
          Awaited<ReturnType<typeof listAutomationRevisions>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationRevisions<
  TData = Awaited<ReturnType<typeof listAutomationRevisions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationRevisionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationRevisions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ListAutomationRevisions returns a paginated list of revisions for a specific automation.
Revisions are returned in reverse chronological order (newest first) by default.
 */

export function useListAutomationRevisions<
  TData = Awaited<ReturnType<typeof listAutomationRevisions>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationRevisionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationRevisions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAutomationRevisionsQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary GetAutomationRevision retrieves a specific revision (version) of an automation.
Returns a snapshot of the automation at the requested revision.
Revisions are identified by their semantic version (e.g., "0.1", "1.0", "2.0").
 */
export const getAutomationRevision = (
  organization: string,
  workspace: string,
  automation: string,
  revision: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AutomationRevision>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/revisions/${revision}`,
    options,
  );
};

export const getGetAutomationRevisionQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  revision?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/revisions/${revision}`,
  ] as const;
};

export const getGetAutomationRevisionQueryOptions = <
  TData = Awaited<ReturnType<typeof getAutomationRevision>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  revision: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationRevision>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAutomationRevisionQueryKey(
      organization,
      workspace,
      automation,
      revision,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAutomationRevision>>
  > = ({ signal }) =>
    getAutomationRevision(organization, workspace, automation, revision, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation && revision),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAutomationRevision>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAutomationRevisionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAutomationRevision>>
>;
export type GetAutomationRevisionQueryError = AxiosError<RpcStatus>;

export function useGetAutomationRevision<
  TData = Awaited<ReturnType<typeof getAutomationRevision>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  revision: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationRevision>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutomationRevision>>,
          TError,
          Awaited<ReturnType<typeof getAutomationRevision>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAutomationRevision<
  TData = Awaited<ReturnType<typeof getAutomationRevision>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  revision: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationRevision>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutomationRevision>>,
          TError,
          Awaited<ReturnType<typeof getAutomationRevision>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAutomationRevision<
  TData = Awaited<ReturnType<typeof getAutomationRevision>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  revision: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationRevision>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary GetAutomationRevision retrieves a specific revision (version) of an automation.
Returns a snapshot of the automation at the requested revision.
Revisions are identified by their semantic version (e.g., "0.1", "1.0", "2.0").
 */

export function useGetAutomationRevision<
  TData = Awaited<ReturnType<typeof getAutomationRevision>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  revision: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationRevision>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAutomationRevisionQueryOptions(
    organization,
    workspace,
    automation,
    revision,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary ListAutomationRevisionSummaries returns a paginated list of lightweight revision
summaries for a specific automation. It mirrors ListAutomationRevisions but omits
the heavy `code` (SPy) and `description` fields from each revision's snapshot,
keeping responses small enough for version-history list views and avoiding oversized
responses that exceed the API gateway's gRPC-JSON transcoding buffer.
Revisions are returned in reverse chronological order (newest first) by default.
 */
export const listAutomationRevisionSummaries = (
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationRevisionSummariesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAutomationRevisionSummariesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/revisions:listSummaries`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListAutomationRevisionSummariesQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: ListAutomationRevisionSummariesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/revisions:listSummaries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAutomationRevisionSummariesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationRevisionSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAutomationRevisionSummariesQueryKey(
      organization,
      workspace,
      automation,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAutomationRevisionSummaries>>
  > = ({ signal }) =>
    listAutomationRevisionSummaries(
      organization,
      workspace,
      automation,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAutomationRevisionSummariesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAutomationRevisionSummaries>>
>;
export type ListAutomationRevisionSummariesQueryError = AxiosError<RpcStatus>;

export function useListAutomationRevisionSummaries<
  TData = Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: undefined | ListAutomationRevisionSummariesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
          TError,
          Awaited<ReturnType<typeof listAutomationRevisionSummaries>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationRevisionSummaries<
  TData = Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationRevisionSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
          TError,
          Awaited<ReturnType<typeof listAutomationRevisionSummaries>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationRevisionSummaries<
  TData = Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationRevisionSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ListAutomationRevisionSummaries returns a paginated list of lightweight revision
summaries for a specific automation. It mirrors ListAutomationRevisions but omits
the heavy `code` (SPy) and `description` fields from each revision's snapshot,
keeping responses small enough for version-history list views and avoiding oversized
responses that exceed the API gateway's gRPC-JSON transcoding buffer.
Revisions are returned in reverse chronological order (newest first) by default.
 */

export function useListAutomationRevisionSummaries<
  TData = Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListAutomationRevisionSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationRevisionSummaries>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAutomationRevisionSummariesQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary GetAutomationSchedule retrieves the schedule for an automation.
Returns NOT_FOUND if no schedule exists for the automation.
Per AIP-131, this is a standard Get method for a singleton sub-resource.
 */
export const getAutomationSchedule = (
  organization: string,
  workspace: string,
  automation: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AutomationSchedule>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/schedule`,
    options,
  );
};

export const getGetAutomationScheduleQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/schedule`,
  ] as const;
};

export const getGetAutomationScheduleQueryOptions = <
  TData = Awaited<ReturnType<typeof getAutomationSchedule>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationSchedule>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAutomationScheduleQueryKey(organization, workspace, automation);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAutomationSchedule>>
  > = ({ signal }) =>
    getAutomationSchedule(organization, workspace, automation, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAutomationSchedule>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAutomationScheduleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAutomationSchedule>>
>;
export type GetAutomationScheduleQueryError = AxiosError<RpcStatus>;

export function useGetAutomationSchedule<
  TData = Awaited<ReturnType<typeof getAutomationSchedule>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationSchedule>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutomationSchedule>>,
          TError,
          Awaited<ReturnType<typeof getAutomationSchedule>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAutomationSchedule<
  TData = Awaited<ReturnType<typeof getAutomationSchedule>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationSchedule>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutomationSchedule>>,
          TError,
          Awaited<ReturnType<typeof getAutomationSchedule>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAutomationSchedule<
  TData = Awaited<ReturnType<typeof getAutomationSchedule>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationSchedule>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary GetAutomationSchedule retrieves the schedule for an automation.
Returns NOT_FOUND if no schedule exists for the automation.
Per AIP-131, this is a standard Get method for a singleton sub-resource.
 */

export function useGetAutomationSchedule<
  TData = Awaited<ReturnType<typeof getAutomationSchedule>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationSchedule>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAutomationScheduleQueryOptions(
    organization,
    workspace,
    automation,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary DeleteAutomationSchedule removes a schedule from an automation.
Per AIP-135, this is a standard Delete method for a singleton sub-resource.
 */
export const deleteAutomationSchedule = (
  organization: string,
  workspace: string,
  automation: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteAutomationSchedule200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/schedule`,
    options,
  );
};

export const getDeleteAutomationScheduleMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAutomationSchedule>>,
    TError,
    { organization: string; workspace: string; automation: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAutomationSchedule>>,
  TError,
  { organization: string; workspace: string; automation: string },
  TContext
> => {
  const mutationKey = ['deleteAutomationSchedule'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAutomationSchedule>>,
    { organization: string; workspace: string; automation: string }
  > = props => {
    const { organization, workspace, automation } = props ?? {};

    return deleteAutomationSchedule(
      organization,
      workspace,
      automation,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAutomationScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAutomationSchedule>>
>;

export type DeleteAutomationScheduleMutationError = AxiosError<RpcStatus>;

/**
 * @summary DeleteAutomationSchedule removes a schedule from an automation.
Per AIP-135, this is a standard Delete method for a singleton sub-resource.
 */
export const useDeleteAutomationSchedule = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAutomationSchedule>>,
      TError,
      { organization: string; workspace: string; automation: string },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAutomationSchedule>>,
  TError,
  { organization: string; workspace: string; automation: string },
  TContext
> => {
  const mutationOptions = getDeleteAutomationScheduleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary CreateAutomationSchedule creates a cron schedule for an automation.
The automation must have a published version to be scheduled.
Schedules always invoke the latest published version.
Returns ALREADY_EXISTS if a schedule already exists for the automation.
 */
export const createAutomationSchedule = (
  organization: string,
  workspace: string,
  automation: string,
  v1AutomationSchedule: NonReadonly<V1AutomationSchedule>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AutomationSchedule>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/schedule`,
    v1AutomationSchedule,
    options,
  );
};

export const getCreateAutomationScheduleMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAutomationSchedule>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: NonReadonly<V1AutomationSchedule>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAutomationSchedule>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: NonReadonly<V1AutomationSchedule>;
  },
  TContext
> => {
  const mutationKey = ['createAutomationSchedule'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAutomationSchedule>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: NonReadonly<V1AutomationSchedule>;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return createAutomationSchedule(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAutomationScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAutomationSchedule>>
>;
export type CreateAutomationScheduleMutationBody =
  NonReadonly<V1AutomationSchedule>;
export type CreateAutomationScheduleMutationError = AxiosError<RpcStatus>;

/**
 * @summary CreateAutomationSchedule creates a cron schedule for an automation.
The automation must have a published version to be scheduled.
Schedules always invoke the latest published version.
Returns ALREADY_EXISTS if a schedule already exists for the automation.
 */
export const useCreateAutomationSchedule = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAutomationSchedule>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: NonReadonly<V1AutomationSchedule>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAutomationSchedule>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: NonReadonly<V1AutomationSchedule>;
  },
  TContext
> => {
  const mutationOptions = getCreateAutomationScheduleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary UpdateAutomationSchedule updates an existing cron schedule for an automation.
Returns NOT_FOUND if no schedule exists for the automation.
 */
export const updateAutomationSchedule = (
  organization: string,
  workspace: string,
  automation: string,
  updateAutomationScheduleBody: NonReadonly<UpdateAutomationScheduleBody>,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AutomationSchedule>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/schedule`,
    updateAutomationScheduleBody,
    options,
  );
};

export const getUpdateAutomationScheduleMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAutomationSchedule>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: NonReadonly<UpdateAutomationScheduleBody>;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAutomationSchedule>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: NonReadonly<UpdateAutomationScheduleBody>;
  },
  TContext
> => {
  const mutationKey = ['updateAutomationSchedule'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAutomationSchedule>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: NonReadonly<UpdateAutomationScheduleBody>;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return updateAutomationSchedule(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAutomationScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAutomationSchedule>>
>;
export type UpdateAutomationScheduleMutationBody =
  NonReadonly<UpdateAutomationScheduleBody>;
export type UpdateAutomationScheduleMutationError = AxiosError<RpcStatus>;

/**
 * @summary UpdateAutomationSchedule updates an existing cron schedule for an automation.
Returns NOT_FOUND if no schedule exists for the automation.
 */
export const useUpdateAutomationSchedule = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAutomationSchedule>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: NonReadonly<UpdateAutomationScheduleBody>;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAutomationSchedule>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: NonReadonly<UpdateAutomationScheduleBody>;
  },
  TContext
> => {
  const mutationOptions = getUpdateAutomationScheduleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary InspectStepConfig reads the current candidate/tuned overlay for an automation
stage. Read-only. Per AIP-136, a custom method (:inspectStepConfig) — not a
standard AIP-131 Get: there is no standalone StepConfig resource, and the
overlay is addressed by parent automation + stage.
 */
export const inspectStepConfig = (
  organization: string,
  workspace: string,
  automation: string,
  params: InspectStepConfigParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1InspectStepConfigResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/stepConfig`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getInspectStepConfigQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: InspectStepConfigParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/stepConfig`,
    ...(params ? [params] : []),
  ] as const;
};

export const getInspectStepConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof inspectStepConfig>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: InspectStepConfigParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof inspectStepConfig>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getInspectStepConfigQueryKey(organization, workspace, automation, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof inspectStepConfig>>
  > = ({ signal }) =>
    inspectStepConfig(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof inspectStepConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type InspectStepConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof inspectStepConfig>>
>;
export type InspectStepConfigQueryError = AxiosError<RpcStatus>;

export function useInspectStepConfig<
  TData = Awaited<ReturnType<typeof inspectStepConfig>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: InspectStepConfigParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof inspectStepConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inspectStepConfig>>,
          TError,
          Awaited<ReturnType<typeof inspectStepConfig>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useInspectStepConfig<
  TData = Awaited<ReturnType<typeof inspectStepConfig>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: InspectStepConfigParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof inspectStepConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inspectStepConfig>>,
          TError,
          Awaited<ReturnType<typeof inspectStepConfig>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useInspectStepConfig<
  TData = Awaited<ReturnType<typeof inspectStepConfig>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: InspectStepConfigParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof inspectStepConfig>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary InspectStepConfig reads the current candidate/tuned overlay for an automation
stage. Read-only. Per AIP-136, a custom method (:inspectStepConfig) — not a
standard AIP-131 Get: there is no standalone StepConfig resource, and the
overlay is addressed by parent automation + stage.
 */

export function useInspectStepConfig<
  TData = Awaited<ReturnType<typeof inspectStepConfig>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: InspectStepConfigParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof inspectStepConfig>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getInspectStepConfigQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary TuneStepConfig upserts candidate/tuned value-slot values for an automation's
DRAFT — the durable store behind uncommitted step testing. Keys are
ValueSlot.path (from IdentifyStepValueSlots). Values present are upserted; a
value of NullValue clears that key. These are applied at run time (via the
Jarvis arg-override, surfaced through BuildStepHarness.tunable_slots) without
editing source; PromoteParamsToCode bakes the winner into code.
Per AIP-136, a custom method (:tuneStepConfig).
 */
export const tuneStepConfig = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceTuneStepConfigBody: AutomationServiceTuneStepConfigBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1TuneStepConfigResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/stepConfig`,
    automationServiceTuneStepConfigBody,
    options,
  );
};

export const getTuneStepConfigMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tuneStepConfig>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceTuneStepConfigBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tuneStepConfig>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceTuneStepConfigBody;
  },
  TContext
> => {
  const mutationKey = ['tuneStepConfig'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tuneStepConfig>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceTuneStepConfigBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return tuneStepConfig(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type TuneStepConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof tuneStepConfig>>
>;
export type TuneStepConfigMutationBody = AutomationServiceTuneStepConfigBody;
export type TuneStepConfigMutationError = AxiosError<RpcStatus>;

/**
 * @summary TuneStepConfig upserts candidate/tuned value-slot values for an automation's
DRAFT — the durable store behind uncommitted step testing. Keys are
ValueSlot.path (from IdentifyStepValueSlots). Values present are upserted; a
value of NullValue clears that key. These are applied at run time (via the
Jarvis arg-override, surfaced through BuildStepHarness.tunable_slots) without
editing source; PromoteParamsToCode bakes the winner into code.
Per AIP-136, a custom method (:tuneStepConfig).
 */
export const useTuneStepConfig = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof tuneStepConfig>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceTuneStepConfigBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof tuneStepConfig>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceTuneStepConfigBody;
  },
  TContext
> => {
  const mutationOptions = getTuneStepConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary BuildStepHarness generates an "options-as-input" wrapper for a step so it can
be run live over multiple inputs (via alfred's step evals) without editing the
real automation: the chosen value slots become harness parameters. Read-only.
Per AIP-136, a custom method (:buildStepHarness).
 */
export const buildStepHarness = (
  organization: string,
  workspace: string,
  automation: string,
  params: BuildStepHarnessParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BuildStepHarnessResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/stepHarness`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getBuildStepHarnessQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: BuildStepHarnessParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/stepHarness`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBuildStepHarnessQueryOptions = <
  TData = Awaited<ReturnType<typeof buildStepHarness>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: BuildStepHarnessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof buildStepHarness>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBuildStepHarnessQueryKey(organization, workspace, automation, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof buildStepHarness>>
  > = ({ signal }) =>
    buildStepHarness(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof buildStepHarness>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BuildStepHarnessQueryResult = NonNullable<
  Awaited<ReturnType<typeof buildStepHarness>>
>;
export type BuildStepHarnessQueryError = AxiosError<RpcStatus>;

export function useBuildStepHarness<
  TData = Awaited<ReturnType<typeof buildStepHarness>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: BuildStepHarnessParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof buildStepHarness>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof buildStepHarness>>,
          TError,
          Awaited<ReturnType<typeof buildStepHarness>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBuildStepHarness<
  TData = Awaited<ReturnType<typeof buildStepHarness>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: BuildStepHarnessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof buildStepHarness>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof buildStepHarness>>,
          TError,
          Awaited<ReturnType<typeof buildStepHarness>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBuildStepHarness<
  TData = Awaited<ReturnType<typeof buildStepHarness>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: BuildStepHarnessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof buildStepHarness>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary BuildStepHarness generates an "options-as-input" wrapper for a step so it can
be run live over multiple inputs (via alfred's step evals) without editing the
real automation: the chosen value slots become harness parameters. Read-only.
Per AIP-136, a custom method (:buildStepHarness).
 */

export function useBuildStepHarness<
  TData = Awaited<ReturnType<typeof buildStepHarness>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: BuildStepHarnessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof buildStepHarness>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBuildStepHarnessQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary IdentifyStepValueSlots returns the editable value slots of a step — the IDP
prompt/options (inline literals or nested options fields) and any constants
the step consumes (even when defined elsewhere in the code) — for step-level
tuning. Read-only. Per AIP-136, a custom method (:identifyStepValueSlots).
 */
export const identifyStepValueSlots = (
  organization: string,
  workspace: string,
  automation: string,
  params: IdentifyStepValueSlotsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1IdentifyStepValueSlotsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/valueSlots`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getIdentifyStepValueSlotsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: IdentifyStepValueSlotsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/valueSlots`,
    ...(params ? [params] : []),
  ] as const;
};

export const getIdentifyStepValueSlotsQueryOptions = <
  TData = Awaited<ReturnType<typeof identifyStepValueSlots>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: IdentifyStepValueSlotsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof identifyStepValueSlots>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getIdentifyStepValueSlotsQueryKey(
      organization,
      workspace,
      automation,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof identifyStepValueSlots>>
  > = ({ signal }) =>
    identifyStepValueSlots(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof identifyStepValueSlots>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IdentifyStepValueSlotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof identifyStepValueSlots>>
>;
export type IdentifyStepValueSlotsQueryError = AxiosError<RpcStatus>;

export function useIdentifyStepValueSlots<
  TData = Awaited<ReturnType<typeof identifyStepValueSlots>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: IdentifyStepValueSlotsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof identifyStepValueSlots>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identifyStepValueSlots>>,
          TError,
          Awaited<ReturnType<typeof identifyStepValueSlots>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIdentifyStepValueSlots<
  TData = Awaited<ReturnType<typeof identifyStepValueSlots>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: IdentifyStepValueSlotsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof identifyStepValueSlots>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identifyStepValueSlots>>,
          TError,
          Awaited<ReturnType<typeof identifyStepValueSlots>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIdentifyStepValueSlots<
  TData = Awaited<ReturnType<typeof identifyStepValueSlots>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: IdentifyStepValueSlotsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof identifyStepValueSlots>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary IdentifyStepValueSlots returns the editable value slots of a step — the IDP
prompt/options (inline literals or nested options fields) and any constants
the step consumes (even when defined elsewhere in the code) — for step-level
tuning. Read-only. Per AIP-136, a custom method (:identifyStepValueSlots).
 */

export function useIdentifyStepValueSlots<
  TData = Awaited<ReturnType<typeof identifyStepValueSlots>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: IdentifyStepValueSlotsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof identifyStepValueSlots>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getIdentifyStepValueSlotsQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary GetAutomationVisualization retrieves the visualization for the latest published
version of an automation. Visualizations are pre-generated configurations
that represent the automation's execution flow.
Per AIP-131, this is a standard Get method.
 */
export const getAutomationVisualization = (
  organization: string,
  workspace: string,
  automation: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AutomationVisualization>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/visualization`,
    options,
  );
};

export const getGetAutomationVisualizationQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}/visualization`,
  ] as const;
};

export const getGetAutomationVisualizationQueryOptions = <
  TData = Awaited<ReturnType<typeof getAutomationVisualization>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationVisualization>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAutomationVisualizationQueryKey(organization, workspace, automation);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAutomationVisualization>>
  > = ({ signal }) =>
    getAutomationVisualization(organization, workspace, automation, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAutomationVisualization>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAutomationVisualizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAutomationVisualization>>
>;
export type GetAutomationVisualizationQueryError = AxiosError<RpcStatus>;

export function useGetAutomationVisualization<
  TData = Awaited<ReturnType<typeof getAutomationVisualization>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationVisualization>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutomationVisualization>>,
          TError,
          Awaited<ReturnType<typeof getAutomationVisualization>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAutomationVisualization<
  TData = Awaited<ReturnType<typeof getAutomationVisualization>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationVisualization>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutomationVisualization>>,
          TError,
          Awaited<ReturnType<typeof getAutomationVisualization>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAutomationVisualization<
  TData = Awaited<ReturnType<typeof getAutomationVisualization>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationVisualization>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary GetAutomationVisualization retrieves the visualization for the latest published
version of an automation. Visualizations are pre-generated configurations
that represent the automation's execution flow.
Per AIP-131, this is a standard Get method.
 */

export function useGetAutomationVisualization<
  TData = Awaited<ReturnType<typeof getAutomationVisualization>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAutomationVisualization>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAutomationVisualizationQueryOptions(
    organization,
    workspace,
    automation,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Per AIP-136, this is a custom method using the :activate suffix.
 * @summary ActivateAutomation reactivates a previously deactivated automation.
This allows the automation to execute new runs again.
Returns FAILED_PRECONDITION if:
  - The automation has no published version
  - The automation is already active
 */
export const activateAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceActivateAutomationBody: AutomationServiceActivateAutomationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ActivateAutomationResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:activate`,
    automationServiceActivateAutomationBody,
    options,
  );
};

export const getActivateAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceActivateAutomationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceActivateAutomationBody;
  },
  TContext
> => {
  const mutationKey = ['activateAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceActivateAutomationBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return activateAutomation(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateAutomation>>
>;
export type ActivateAutomationMutationBody =
  AutomationServiceActivateAutomationBody;
export type ActivateAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary ActivateAutomation reactivates a previously deactivated automation.
This allows the automation to execute new runs again.
Returns FAILED_PRECONDITION if:
  - The automation has no published version
  - The automation is already active
 */
export const useActivateAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activateAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceActivateAutomationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof activateAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceActivateAutomationBody;
  },
  TContext
> => {
  const mutationOptions = getActivateAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Multiple connections can be added in a single atomic operation. All additions succeed
together or all fail together. The automation version is incremented once for all additions.

This operation only works on draft automations. To add connections to a published
automation, first use ForkPublishedAutomation to create a draft, then call this method.

Per AIP-136, this is a custom method using the :addConnections suffix.
 * @summary AddAutomationConnections adds new connections to an automation.
This allows adding connection metadata and making those connections available to the automation.
 */
export const addAutomationConnections = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceAddAutomationConnectionsBody: AutomationServiceAddAutomationConnectionsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1AddAutomationConnectionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:addConnections`,
    automationServiceAddAutomationConnectionsBody,
    options,
  );
};

export const getAddAutomationConnectionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addAutomationConnections>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceAddAutomationConnectionsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addAutomationConnections>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceAddAutomationConnectionsBody;
  },
  TContext
> => {
  const mutationKey = ['addAutomationConnections'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addAutomationConnections>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceAddAutomationConnectionsBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return addAutomationConnections(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AddAutomationConnectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof addAutomationConnections>>
>;
export type AddAutomationConnectionsMutationBody =
  AutomationServiceAddAutomationConnectionsBody;
export type AddAutomationConnectionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary AddAutomationConnections adds new connections to an automation.
This allows adding connection metadata and making those connections available to the automation.
 */
export const useAddAutomationConnections = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addAutomationConnections>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceAddAutomationConnectionsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addAutomationConnections>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceAddAutomationConnectionsBody;
  },
  TContext
> => {
  const mutationOptions = getAddAutomationConnectionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Per AIP-136, this is a custom method using the :deactivate suffix.
 * @summary DeactivateAutomation stops an automation from executing new runs.
All events (scheduled, manual, webhook) will be logged but not executed.
The automation can be reactivated at any time using ActivateAutomation.
Returns FAILED_PRECONDITION if:
  - The automation has no published version
  - The automation is already deactivated
 */
export const deactivateAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceDeactivateAutomationBody: AutomationServiceDeactivateAutomationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeactivateAutomationResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:deactivate`,
    automationServiceDeactivateAutomationBody,
    options,
  );
};

export const getDeactivateAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceDeactivateAutomationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceDeactivateAutomationBody;
  },
  TContext
> => {
  const mutationKey = ['deactivateAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceDeactivateAutomationBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return deactivateAutomation(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivateAutomation>>
>;
export type DeactivateAutomationMutationBody =
  AutomationServiceDeactivateAutomationBody;
export type DeactivateAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary DeactivateAutomation stops an automation from executing new runs.
All events (scheduled, manual, webhook) will be logged but not executed.
The automation can be reactivated at any time using ActivateAutomation.
Returns FAILED_PRECONDITION if:
  - The automation has no published version
  - The automation is already deactivated
 */
export const useDeactivateAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deactivateAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceDeactivateAutomationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deactivateAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceDeactivateAutomationBody;
  },
  TContext
> => {
  const mutationOptions = getDeactivateAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary DisableAutomationSchedule pauses a schedule without deleting it.
The schedule can be re-enabled using EnableAutomationSchedule.
Per AIP-136, this is a custom method using the :disableAutomationSchedule suffix.
 */
export const disableAutomationSchedule = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceDisableAutomationScheduleBody: AutomationServiceDisableAutomationScheduleBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DisableAutomationScheduleResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:disableAutomationSchedule`,
    automationServiceDisableAutomationScheduleBody,
    options,
  );
};

export const getDisableAutomationScheduleMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableAutomationSchedule>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceDisableAutomationScheduleBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disableAutomationSchedule>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceDisableAutomationScheduleBody;
  },
  TContext
> => {
  const mutationKey = ['disableAutomationSchedule'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disableAutomationSchedule>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceDisableAutomationScheduleBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return disableAutomationSchedule(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DisableAutomationScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof disableAutomationSchedule>>
>;
export type DisableAutomationScheduleMutationBody =
  AutomationServiceDisableAutomationScheduleBody;
export type DisableAutomationScheduleMutationError = AxiosError<RpcStatus>;

/**
 * @summary DisableAutomationSchedule pauses a schedule without deleting it.
The schedule can be re-enabled using EnableAutomationSchedule.
Per AIP-136, this is a custom method using the :disableAutomationSchedule suffix.
 */
export const useDisableAutomationSchedule = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disableAutomationSchedule>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceDisableAutomationScheduleBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof disableAutomationSchedule>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceDisableAutomationScheduleBody;
  },
  TContext
> => {
  const mutationOptions = getDisableAutomationScheduleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary DuplicateAutomation creates a new automation by copying an existing one within the same workspace.
The duplicated automation is a new, independent entity with its own identity, ownership, and version history.
Only the specified stage (draft or published) is copied, not the full version history.
All phases (MAIN, POST, and PRE if they exist) are copied.
Connections are copied by reference within the same workspace.
If display_name is provided in the request, the duplicated automation uses that name;
otherwise the server generates a default name based on the source automation's display name.
Per AIP-136, this is a custom method using the :duplicate suffix.
 */
export const duplicateAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceDuplicateAutomationBody: AutomationServiceDuplicateAutomationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DuplicateAutomationResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:duplicate`,
    automationServiceDuplicateAutomationBody,
    options,
  );
};

export const getDuplicateAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceDuplicateAutomationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceDuplicateAutomationBody;
  },
  TContext
> => {
  const mutationKey = ['duplicateAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceDuplicateAutomationBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return duplicateAutomation(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateAutomation>>
>;
export type DuplicateAutomationMutationBody =
  AutomationServiceDuplicateAutomationBody;
export type DuplicateAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary DuplicateAutomation creates a new automation by copying an existing one within the same workspace.
The duplicated automation is a new, independent entity with its own identity, ownership, and version history.
Only the specified stage (draft or published) is copied, not the full version history.
All phases (MAIN, POST, and PRE if they exist) are copied.
Connections are copied by reference within the same workspace.
If display_name is provided in the request, the duplicated automation uses that name;
otherwise the server generates a default name based on the source automation's display name.
Per AIP-136, this is a custom method using the :duplicate suffix.
 */
export const useDuplicateAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof duplicateAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceDuplicateAutomationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceDuplicateAutomationBody;
  },
  TContext
> => {
  const mutationOptions = getDuplicateAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary EnableAutomationSchedule resumes a previously disabled schedule.
Per AIP-136, this is a custom method using the :enableAutomationSchedule suffix.
 */
export const enableAutomationSchedule = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceEnableAutomationScheduleBody: AutomationServiceEnableAutomationScheduleBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1EnableAutomationScheduleResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:enableAutomationSchedule`,
    automationServiceEnableAutomationScheduleBody,
    options,
  );
};

export const getEnableAutomationScheduleMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enableAutomationSchedule>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceEnableAutomationScheduleBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enableAutomationSchedule>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceEnableAutomationScheduleBody;
  },
  TContext
> => {
  const mutationKey = ['enableAutomationSchedule'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enableAutomationSchedule>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceEnableAutomationScheduleBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return enableAutomationSchedule(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type EnableAutomationScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof enableAutomationSchedule>>
>;
export type EnableAutomationScheduleMutationBody =
  AutomationServiceEnableAutomationScheduleBody;
export type EnableAutomationScheduleMutationError = AxiosError<RpcStatus>;

/**
 * @summary EnableAutomationSchedule resumes a previously disabled schedule.
Per AIP-136, this is a custom method using the :enableAutomationSchedule suffix.
 */
export const useEnableAutomationSchedule = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enableAutomationSchedule>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceEnableAutomationScheduleBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof enableAutomationSchedule>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceEnableAutomationScheduleBody;
  },
  TContext
> => {
  const mutationOptions = getEnableAutomationScheduleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ExtractAutomationCodeConnections returns all connections used in the SPy code of an automation.
This includes both placeholder connections and concrete connections with IDs.
Per AIP-136, this is a custom method using the :extractCodeConnections suffix.
 */
export const extractAutomationCodeConnections = (
  organization: string,
  workspace: string,
  automation: string,
  params: ExtractAutomationCodeConnectionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ExtractAutomationCodeConnectionsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:extractCodeConnections`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getExtractAutomationCodeConnectionsQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: ExtractAutomationCodeConnectionsParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:extractCodeConnections`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExtractAutomationCodeConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: ExtractAutomationCodeConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExtractAutomationCodeConnectionsQueryKey(
      organization,
      workspace,
      automation,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof extractAutomationCodeConnections>>
  > = ({ signal }) =>
    extractAutomationCodeConnections(
      organization,
      workspace,
      automation,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExtractAutomationCodeConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof extractAutomationCodeConnections>>
>;
export type ExtractAutomationCodeConnectionsQueryError = AxiosError<RpcStatus>;

export function useExtractAutomationCodeConnections<
  TData = Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: ExtractAutomationCodeConnectionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
          TError,
          Awaited<ReturnType<typeof extractAutomationCodeConnections>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExtractAutomationCodeConnections<
  TData = Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: ExtractAutomationCodeConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
          TError,
          Awaited<ReturnType<typeof extractAutomationCodeConnections>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExtractAutomationCodeConnections<
  TData = Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: ExtractAutomationCodeConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ExtractAutomationCodeConnections returns all connections used in the SPy code of an automation.
This includes both placeholder connections and concrete connections with IDs.
Per AIP-136, this is a custom method using the :extractCodeConnections suffix.
 */

export function useExtractAutomationCodeConnections<
  TData = Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: ExtractAutomationCodeConnectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof extractAutomationCodeConnections>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExtractAutomationCodeConnectionsQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary ForkPublishedAutomation creates a draft from the last published version of an automation.
This effectively resets the draft state to match the published state.
Per AIP-136, this is a custom method using the :fork suffix.
 */
export const forkPublishedAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceForkPublishedAutomationBody: AutomationServiceForkPublishedAutomationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ForkPublishedAutomationResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:fork`,
    automationServiceForkPublishedAutomationBody,
    options,
  );
};

export const getForkPublishedAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forkPublishedAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceForkPublishedAutomationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof forkPublishedAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceForkPublishedAutomationBody;
  },
  TContext
> => {
  const mutationKey = ['forkPublishedAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forkPublishedAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceForkPublishedAutomationBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return forkPublishedAutomation(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ForkPublishedAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof forkPublishedAutomation>>
>;
export type ForkPublishedAutomationMutationBody =
  AutomationServiceForkPublishedAutomationBody;
export type ForkPublishedAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary ForkPublishedAutomation creates a draft from the last published version of an automation.
This effectively resets the draft state to match the published state.
Per AIP-136, this is a custom method using the :fork suffix.
 */
export const useForkPublishedAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof forkPublishedAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceForkPublishedAutomationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof forkPublishedAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceForkPublishedAutomationBody;
  },
  TContext
> => {
  const mutationOptions = getForkPublishedAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The visualization is generated asynchronously. This method returns immediately
with state VISUALIZATION_STATE_PENDING. Use GetAutomationVisualization to poll
for completion.

Returns FAILED_PRECONDITION if the automation has no published version.

Per AIP-136, this is a custom method using the :generateVisualization suffix.
 * @summary GenerateAutomationVisualization triggers visualization generation for the latest
published version of an automation. This always regenerates the visualization,
even if one already exists.
 */
export const generateAutomationVisualization = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceGenerateAutomationVisualizationBody: AutomationServiceGenerateAutomationVisualizationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GenerateAutomationVisualizationResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:generateVisualization`,
    automationServiceGenerateAutomationVisualizationBody,
    options,
  );
};

export const getGenerateAutomationVisualizationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateAutomationVisualization>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceGenerateAutomationVisualizationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateAutomationVisualization>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceGenerateAutomationVisualizationBody;
  },
  TContext
> => {
  const mutationKey = ['generateAutomationVisualization'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateAutomationVisualization>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceGenerateAutomationVisualizationBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return generateAutomationVisualization(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateAutomationVisualizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateAutomationVisualization>>
>;
export type GenerateAutomationVisualizationMutationBody =
  AutomationServiceGenerateAutomationVisualizationBody;
export type GenerateAutomationVisualizationMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary GenerateAutomationVisualization triggers visualization generation for the latest
published version of an automation. This always regenerates the visualization,
even if one already exists.
 */
export const useGenerateAutomationVisualization = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateAutomationVisualization>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceGenerateAutomationVisualizationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateAutomationVisualization>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceGenerateAutomationVisualizationBody;
  },
  TContext
> => {
  const mutationOptions =
    getGenerateAutomationVisualizationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary InvokeAutomation executes an automation with the provided inputs.
Creates a new run instance and returns the run ID for tracking execution status.
 */
export const invokeAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceInvokeAutomationBody: AutomationServiceInvokeAutomationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1InvokeAutomationResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:invoke`,
    automationServiceInvokeAutomationBody,
    options,
  );
};

export const getInvokeAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invokeAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceInvokeAutomationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invokeAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceInvokeAutomationBody;
  },
  TContext
> => {
  const mutationKey = ['invokeAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invokeAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceInvokeAutomationBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return invokeAutomation(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type InvokeAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof invokeAutomation>>
>;
export type InvokeAutomationMutationBody =
  AutomationServiceInvokeAutomationBody;
export type InvokeAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary InvokeAutomation executes an automation with the provided inputs.
Creates a new run instance and returns the run ID for tracking execution status.
 */
export const useInvokeAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof invokeAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceInvokeAutomationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof invokeAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceInvokeAutomationBody;
  },
  TContext
> => {
  const mutationOptions = getInvokeAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Results are returned in reverse chronological order (newest first).
Optionally filter by stage (DRAFT or PUBLISHED).
 * @summary ListDefaultInputsHistory returns a paginated history of default input changes
for an automation. Each entry captures a snapshot of the default inputs at the
time of change, along with who made the change and when.
 */
export const listDefaultInputsHistory = (
  organization: string,
  workspace: string,
  automation: string,
  params?: ListDefaultInputsHistoryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListDefaultInputsHistoryResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:listDefaultInputsHistory`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListDefaultInputsHistoryQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: ListDefaultInputsHistoryParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:listDefaultInputsHistory`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListDefaultInputsHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listDefaultInputsHistory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListDefaultInputsHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDefaultInputsHistory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListDefaultInputsHistoryQueryKey(
      organization,
      workspace,
      automation,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDefaultInputsHistory>>
  > = ({ signal }) =>
    listDefaultInputsHistory(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDefaultInputsHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDefaultInputsHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDefaultInputsHistory>>
>;
export type ListDefaultInputsHistoryQueryError = AxiosError<RpcStatus>;

export function useListDefaultInputsHistory<
  TData = Awaited<ReturnType<typeof listDefaultInputsHistory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: undefined | ListDefaultInputsHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDefaultInputsHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDefaultInputsHistory>>,
          TError,
          Awaited<ReturnType<typeof listDefaultInputsHistory>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDefaultInputsHistory<
  TData = Awaited<ReturnType<typeof listDefaultInputsHistory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListDefaultInputsHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDefaultInputsHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDefaultInputsHistory>>,
          TError,
          Awaited<ReturnType<typeof listDefaultInputsHistory>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDefaultInputsHistory<
  TData = Awaited<ReturnType<typeof listDefaultInputsHistory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListDefaultInputsHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDefaultInputsHistory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ListDefaultInputsHistory returns a paginated history of default input changes
for an automation. Each entry captures a snapshot of the default inputs at the
time of change, along with who made the change and when.
 */

export function useListDefaultInputsHistory<
  TData = Awaited<ReturnType<typeof listDefaultInputsHistory>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params?: ListDefaultInputsHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDefaultInputsHistory>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListDefaultInputsHistoryQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary GetNextCopyName computes the display name that DuplicateAutomation would assign to a copy
of the given automation, without creating anything. It is read-only and side-effect-free.
The returned name is unique within the source automation's workspace, applying the same
disambiguation rules the duplicate operation uses (e.g. "Copy of X", then "Copy (2) of X").
This lets clients (such as the "Make a copy" modal) pre-fill the name field before submitting.
Per AIP-136, this is a custom method using the :nextCopyName suffix.
 */
export const getNextCopyName = (
  organization: string,
  workspace: string,
  automation: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetNextCopyNameResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:nextCopyName`,
    options,
  );
};

export const getGetNextCopyNameQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:nextCopyName`,
  ] as const;
};

export const getGetNextCopyNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getNextCopyName>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNextCopyName>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetNextCopyNameQueryKey(organization, workspace, automation);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNextCopyName>>> = ({
    signal,
  }) =>
    getNextCopyName(organization, workspace, automation, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNextCopyName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNextCopyNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNextCopyName>>
>;
export type GetNextCopyNameQueryError = AxiosError<RpcStatus>;

export function useGetNextCopyName<
  TData = Awaited<ReturnType<typeof getNextCopyName>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNextCopyName>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextCopyName>>,
          TError,
          Awaited<ReturnType<typeof getNextCopyName>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNextCopyName<
  TData = Awaited<ReturnType<typeof getNextCopyName>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNextCopyName>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNextCopyName>>,
          TError,
          Awaited<ReturnType<typeof getNextCopyName>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNextCopyName<
  TData = Awaited<ReturnType<typeof getNextCopyName>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNextCopyName>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary GetNextCopyName computes the display name that DuplicateAutomation would assign to a copy
of the given automation, without creating anything. It is read-only and side-effect-free.
The returned name is unique within the source automation's workspace, applying the same
disambiguation rules the duplicate operation uses (e.g. "Copy of X", then "Copy (2) of X").
This lets clients (such as the "Make a copy" modal) pre-fill the name field before submitting.
Per AIP-136, this is a custom method using the :nextCopyName suffix.
 */

export function useGetNextCopyName<
  TData = Awaited<ReturnType<typeof getNextCopyName>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNextCopyName>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetNextCopyNameQueryOptions(
    organization,
    workspace,
    automation,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary PreviewAutomationSchedule validates a schedule configuration and returns
a preview without persisting it. Powers the "Preview" panel in the UI,
showing users what times the schedule will run before they commit.
Per AIP-136, this is a custom method using the :previewSchedule suffix.
 */
export const previewAutomationSchedule = (
  organization: string,
  workspace: string,
  automation: string,
  automationServicePreviewAutomationScheduleBody: AutomationServicePreviewAutomationScheduleBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PreviewAutomationScheduleResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:previewSchedule`,
    automationServicePreviewAutomationScheduleBody,
    options,
  );
};

export const getPreviewAutomationScheduleMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAutomationSchedule>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServicePreviewAutomationScheduleBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewAutomationSchedule>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServicePreviewAutomationScheduleBody;
  },
  TContext
> => {
  const mutationKey = ['previewAutomationSchedule'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewAutomationSchedule>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServicePreviewAutomationScheduleBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return previewAutomationSchedule(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewAutomationScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewAutomationSchedule>>
>;
export type PreviewAutomationScheduleMutationBody =
  AutomationServicePreviewAutomationScheduleBody;
export type PreviewAutomationScheduleMutationError = AxiosError<RpcStatus>;

/**
 * @summary PreviewAutomationSchedule validates a schedule configuration and returns
a preview without persisting it. Powers the "Preview" panel in the UI,
showing users what times the schedule will run before they commit.
Per AIP-136, this is a custom method using the :previewSchedule suffix.
 */
export const usePreviewAutomationSchedule = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewAutomationSchedule>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServicePreviewAutomationScheduleBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof previewAutomationSchedule>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServicePreviewAutomationScheduleBody;
  },
  TContext
> => {
  const mutationOptions = getPreviewAutomationScheduleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary PublishAutomation publishes an automation with the provided credentials.
Creates a new immutable AutomationRevision and updates latest_published_version.
Per AIP-136, this is a custom method using the :publish suffix.
 */
export const publishAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  automationServicePublishAutomationBody: AutomationServicePublishAutomationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PublishAutomationResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:publish`,
    automationServicePublishAutomationBody,
    options,
  );
};

export const getPublishAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServicePublishAutomationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServicePublishAutomationBody;
  },
  TContext
> => {
  const mutationKey = ['publishAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServicePublishAutomationBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return publishAutomation(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PublishAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishAutomation>>
>;
export type PublishAutomationMutationBody =
  AutomationServicePublishAutomationBody;
export type PublishAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary PublishAutomation publishes an automation with the provided credentials.
Creates a new immutable AutomationRevision and updates latest_published_version.
Per AIP-136, this is a custom method using the :publish suffix.
 */
export const usePublishAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publishAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServicePublishAutomationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof publishAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServicePublishAutomationBody;
  },
  TContext
> => {
  const mutationOptions = getPublishAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This custom method allows explicit selection of which version stage to retrieve:
- AUTOMATION_STAGE_DRAFT: Returns the latest draft version
- AUTOMATION_STAGE_PUBLISHED: Returns the latest published version
 * @summary QueryAutomation retrieves an automation at a specific stage (draft or published version).
 */
export const queryAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  params: QueryAutomationParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Automation>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:query`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getQueryAutomationQueryKey = (
  organization?: string,
  workspace?: string,
  automation?: string,
  params?: QueryAutomationParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:query`,
    ...(params ? [params] : []),
  ] as const;
};

export const getQueryAutomationQueryOptions = <
  TData = Awaited<ReturnType<typeof queryAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: QueryAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryAutomation>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getQueryAutomationQueryKey(organization, workspace, automation, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof queryAutomation>>> = ({
    signal,
  }) =>
    queryAutomation(organization, workspace, automation, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && automation),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof queryAutomation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type QueryAutomationQueryResult = NonNullable<
  Awaited<ReturnType<typeof queryAutomation>>
>;
export type QueryAutomationQueryError = AxiosError<RpcStatus>;

export function useQueryAutomation<
  TData = Awaited<ReturnType<typeof queryAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: QueryAutomationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryAutomation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryAutomation>>,
          TError,
          Awaited<ReturnType<typeof queryAutomation>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQueryAutomation<
  TData = Awaited<ReturnType<typeof queryAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: QueryAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryAutomation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof queryAutomation>>,
          TError,
          Awaited<ReturnType<typeof queryAutomation>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQueryAutomation<
  TData = Awaited<ReturnType<typeof queryAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: QueryAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryAutomation>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary QueryAutomation retrieves an automation at a specific stage (draft or published version).
 */

export function useQueryAutomation<
  TData = Awaited<ReturnType<typeof queryAutomation>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  automation: string,
  params: QueryAutomationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof queryAutomation>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getQueryAutomationQueryOptions(
    organization,
    workspace,
    automation,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Multiple connections can be removed in a single atomic operation. All removals succeed
together or all fail together. The automation version is incremented once for all removals.

This operation only works on draft automations. To remove connections in a published
automation, first use ForkPublishedAutomation to create a draft, then call this method.

Per AIP-136, this is a custom method using the :removeConnections suffix.
 * @summary RemoveAutomationConnections removes connection metadata and replaces code references
with placeholders (kognitos.connection_name.{book}). This effectively deprovisions
connections, returning the automation to an unpublished state for those connections.
 */
export const removeAutomationConnections = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceRemoveAutomationConnectionsBody: AutomationServiceRemoveAutomationConnectionsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RemoveAutomationConnectionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:removeConnections`,
    automationServiceRemoveAutomationConnectionsBody,
    options,
  );
};

export const getRemoveAutomationConnectionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeAutomationConnections>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceRemoveAutomationConnectionsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeAutomationConnections>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceRemoveAutomationConnectionsBody;
  },
  TContext
> => {
  const mutationKey = ['removeAutomationConnections'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeAutomationConnections>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceRemoveAutomationConnectionsBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return removeAutomationConnections(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveAutomationConnectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeAutomationConnections>>
>;
export type RemoveAutomationConnectionsMutationBody =
  AutomationServiceRemoveAutomationConnectionsBody;
export type RemoveAutomationConnectionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary RemoveAutomationConnections removes connection metadata and replaces code references
with placeholders (kognitos.connection_name.{book}). This effectively deprovisions
connections, returning the automation to an unpublished state for those connections.
 */
export const useRemoveAutomationConnections = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeAutomationConnections>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceRemoveAutomationConnectionsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeAutomationConnections>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceRemoveAutomationConnectionsBody;
  },
  TContext
> => {
  const mutationOptions =
    getRemoveAutomationConnectionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Per AIP-136, this is a custom method using the :rename suffix.
 * @summary RenameAutomation changes the display name of an automation without modifying
the automation content (code, connections, artifacts). This operation does not
increment the automation version since only metadata is changed.
 */
export const renameAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceRenameAutomationBody: AutomationServiceRenameAutomationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Automation>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:rename`,
    automationServiceRenameAutomationBody,
    options,
  );
};

export const getRenameAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceRenameAutomationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceRenameAutomationBody;
  },
  TContext
> => {
  const mutationKey = ['renameAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceRenameAutomationBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return renameAutomation(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RenameAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameAutomation>>
>;
export type RenameAutomationMutationBody =
  AutomationServiceRenameAutomationBody;
export type RenameAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary RenameAutomation changes the display name of an automation without modifying
the automation content (code, connections, artifacts). This operation does not
increment the automation version since only metadata is changed.
 */
export const useRenameAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renameAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceRenameAutomationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof renameAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceRenameAutomationBody;
  },
  TContext
> => {
  const mutationOptions = getRenameAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary RestoreAutomation restores an automation to a previous version.
This copies the snapshot from the specified revision into the current draft,
and populates restore_time, restore_version, and restore_user_id fields.
Per AIP-136, this is a custom method using the :restore suffix.
 */
export const restoreAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceRestoreAutomationBody: AutomationServiceRestoreAutomationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RestoreAutomationResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:restore`,
    automationServiceRestoreAutomationBody,
    options,
  );
};

export const getRestoreAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceRestoreAutomationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceRestoreAutomationBody;
  },
  TContext
> => {
  const mutationKey = ['restoreAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceRestoreAutomationBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return restoreAutomation(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreAutomation>>
>;
export type RestoreAutomationMutationBody =
  AutomationServiceRestoreAutomationBody;
export type RestoreAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary RestoreAutomation restores an automation to a previous version.
This copies the snapshot from the specified revision into the current draft,
and populates restore_time, restore_version, and restore_user_id fields.
Per AIP-136, this is a custom method using the :restore suffix.
 */
export const useRestoreAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceRestoreAutomationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof restoreAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceRestoreAutomationBody;
  },
  TContext
> => {
  const mutationOptions = getRestoreAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * The provided default_inputs are merged with existing defaults:
- Keys present in the request overwrite existing defaults
- Keys with null_value remove the default for that input
- Existing keys not present in the request are preserved

Per AIP-136, this is a custom method using the :setDefaultInputs suffix.
 * @summary SetAutomationDefaultInputs sets or updates default input values for an automation.
Default inputs are used to pre-populate values for manual runs and fill missing
inputs for trigger-based invocations. This operation updates the latest version
of the specified stage in-place without creating a new version.
 */
export const setAutomationDefaultInputs = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceSetAutomationDefaultInputsBody: AutomationServiceSetAutomationDefaultInputsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Automation>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:setDefaultInputs`,
    automationServiceSetAutomationDefaultInputsBody,
    options,
  );
};

export const getSetAutomationDefaultInputsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAutomationDefaultInputs>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceSetAutomationDefaultInputsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAutomationDefaultInputs>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceSetAutomationDefaultInputsBody;
  },
  TContext
> => {
  const mutationKey = ['setAutomationDefaultInputs'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAutomationDefaultInputs>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceSetAutomationDefaultInputsBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return setAutomationDefaultInputs(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAutomationDefaultInputsMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAutomationDefaultInputs>>
>;
export type SetAutomationDefaultInputsMutationBody =
  AutomationServiceSetAutomationDefaultInputsBody;
export type SetAutomationDefaultInputsMutationError = AxiosError<RpcStatus>;

/**
 * @summary SetAutomationDefaultInputs sets or updates default input values for an automation.
Default inputs are used to pre-populate values for manual runs and fill missing
inputs for trigger-based invocations. This operation updates the latest version
of the specified stage in-place without creating a new version.
 */
export const useSetAutomationDefaultInputs = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAutomationDefaultInputs>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceSetAutomationDefaultInputsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAutomationDefaultInputs>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceSetAutomationDefaultInputsBody;
  },
  TContext
> => {
  const mutationOptions = getSetAutomationDefaultInputsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Labels are matched case-insensitively. A label already used in the
workspace under a different casing is stored in that existing spelling.

Per AIP-136, this is a custom method using the :setLabels suffix.
 * @summary SetAutomationLabels replaces the full label set of an automation.
Labels not in the given list are removed and new ones are added.
An empty list removes all labels. Like RenameAutomation, this only
changes metadata and does not create a new automation version.
 */
export const setAutomationLabels = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceSetAutomationLabelsBody: AutomationServiceSetAutomationLabelsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Automation>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:setLabels`,
    automationServiceSetAutomationLabelsBody,
    options,
  );
};

export const getSetAutomationLabelsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAutomationLabels>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceSetAutomationLabelsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAutomationLabels>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceSetAutomationLabelsBody;
  },
  TContext
> => {
  const mutationKey = ['setAutomationLabels'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAutomationLabels>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceSetAutomationLabelsBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return setAutomationLabels(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAutomationLabelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAutomationLabels>>
>;
export type SetAutomationLabelsMutationBody =
  AutomationServiceSetAutomationLabelsBody;
export type SetAutomationLabelsMutationError = AxiosError<RpcStatus>;

/**
 * @summary SetAutomationLabels replaces the full label set of an automation.
Labels not in the given list are removed and new ones are added.
An empty list removes all labels. Like RenameAutomation, this only
changes metadata and does not create a new automation version.
 */
export const useSetAutomationLabels = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAutomationLabels>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceSetAutomationLabelsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAutomationLabels>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceSetAutomationLabelsBody;
  },
  TContext
> => {
  const mutationOptions = getSetAutomationLabelsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Multiple connections can be switched in a single atomic operation. All switches succeed
together or all fail together. The automation version is incremented once for all switches.

This operation only works on draft automations. To switch connections in a published
automation, first use ForkPublishedAutomation to create a draft, then call this method.

Per AIP-136, this is a custom method using the :switchConnections suffix.
 * @summary SwitchAutomationConnections replaces connection references in both the automation code
and metadata. This changes the connection name in the SPy code and updates the connection
metadata, effectively replacing one connection with another.
 */
export const switchAutomationConnections = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceSwitchAutomationConnectionsBody: AutomationServiceSwitchAutomationConnectionsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SwitchAutomationConnectionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:switchConnections`,
    automationServiceSwitchAutomationConnectionsBody,
    options,
  );
};

export const getSwitchAutomationConnectionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof switchAutomationConnections>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceSwitchAutomationConnectionsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof switchAutomationConnections>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceSwitchAutomationConnectionsBody;
  },
  TContext
> => {
  const mutationKey = ['switchAutomationConnections'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof switchAutomationConnections>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceSwitchAutomationConnectionsBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return switchAutomationConnections(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SwitchAutomationConnectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof switchAutomationConnections>>
>;
export type SwitchAutomationConnectionsMutationBody =
  AutomationServiceSwitchAutomationConnectionsBody;
export type SwitchAutomationConnectionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary SwitchAutomationConnections replaces connection references in both the automation code
and metadata. This changes the connection name in the SPy code and updates the connection
metadata, effectively replacing one connection with another.
 */
export const useSwitchAutomationConnections = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof switchAutomationConnections>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceSwitchAutomationConnectionsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof switchAutomationConnections>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceSwitchAutomationConnectionsBody;
  },
  TContext
> => {
  const mutationOptions =
    getSwitchAutomationConnectionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary UndeleteAutomation restores a previously soft-deleted automation.
 */
export const undeleteAutomation = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceUndeleteAutomationBody: AutomationServiceUndeleteAutomationBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1Automation>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:undelete`,
    automationServiceUndeleteAutomationBody,
    options,
  );
};

export const getUndeleteAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof undeleteAutomation>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceUndeleteAutomationBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof undeleteAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceUndeleteAutomationBody;
  },
  TContext
> => {
  const mutationKey = ['undeleteAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof undeleteAutomation>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceUndeleteAutomationBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return undeleteAutomation(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UndeleteAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof undeleteAutomation>>
>;
export type UndeleteAutomationMutationBody =
  AutomationServiceUndeleteAutomationBody;
export type UndeleteAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary UndeleteAutomation restores a previously soft-deleted automation.
 */
export const useUndeleteAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof undeleteAutomation>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceUndeleteAutomationBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof undeleteAutomation>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceUndeleteAutomationBody;
  },
  TContext
> => {
  const mutationOptions = getUndeleteAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This operation only works on draft automations. To upgrade connections in a published
automation, first use ForkPublishedAutomation to create a draft, then call this method.

Per AIP-136, this is a custom method using the :upgradeBookConnectionVersion suffix.
 * @summary UpgradeAutomationBookConnectionVersion upgrades all connections of a specific book
within a draft automation to a specified target version. Every connection whose
book matches will be transitioned to new_book_version in a single atomic update.
The target version does not need to be the latest — any higher version is valid.
 */
export const upgradeAutomationBookConnectionVersion = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceUpgradeAutomationBookConnectionVersionBody: AutomationServiceUpgradeAutomationBookConnectionVersionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpgradeAutomationBookConnectionVersionResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:upgradeBookConnectionVersion`,
    automationServiceUpgradeAutomationBookConnectionVersionBody,
    options,
  );
};

export const getUpgradeAutomationBookConnectionVersionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradeAutomationBookConnectionVersion>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceUpgradeAutomationBookConnectionVersionBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upgradeAutomationBookConnectionVersion>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceUpgradeAutomationBookConnectionVersionBody;
  },
  TContext
> => {
  const mutationKey = ['upgradeAutomationBookConnectionVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradeAutomationBookConnectionVersion>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceUpgradeAutomationBookConnectionVersionBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return upgradeAutomationBookConnectionVersion(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpgradeAutomationBookConnectionVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof upgradeAutomationBookConnectionVersion>>
>;
export type UpgradeAutomationBookConnectionVersionMutationBody =
  AutomationServiceUpgradeAutomationBookConnectionVersionBody;
export type UpgradeAutomationBookConnectionVersionMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary UpgradeAutomationBookConnectionVersion upgrades all connections of a specific book
within a draft automation to a specified target version. Every connection whose
book matches will be transitioned to new_book_version in a single atomic update.
The target version does not need to be the latest — any higher version is valid.
 */
export const useUpgradeAutomationBookConnectionVersion = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upgradeAutomationBookConnectionVersion>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceUpgradeAutomationBookConnectionVersionBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upgradeAutomationBookConnectionVersion>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceUpgradeAutomationBookConnectionVersionBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpgradeAutomationBookConnectionVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Multiple connections can be upgraded in a single atomic operation. All upgrades succeed
together or all fail together. The automation version is incremented once for all upgrades.

This operation only works on draft automations. To upgrade connections in a published
automation, first use ForkPublishedAutomation to create a draft, then call this method.

Per AIP-136, this is a custom method using the :upgradeConnections suffix.
 * @summary UpgradeAutomationConnections updates connection metadata (connection_id, endpoint)
without modifying the automation code. This is the most common operation for upgrading
from test to production credentials while keeping connection names unchanged.
 */
export const upgradeAutomationConnections = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceUpgradeAutomationConnectionsBody: AutomationServiceUpgradeAutomationConnectionsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1UpgradeAutomationConnectionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:upgradeConnections`,
    automationServiceUpgradeAutomationConnectionsBody,
    options,
  );
};

export const getUpgradeAutomationConnectionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradeAutomationConnections>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceUpgradeAutomationConnectionsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upgradeAutomationConnections>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceUpgradeAutomationConnectionsBody;
  },
  TContext
> => {
  const mutationKey = ['upgradeAutomationConnections'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradeAutomationConnections>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceUpgradeAutomationConnectionsBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return upgradeAutomationConnections(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpgradeAutomationConnectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof upgradeAutomationConnections>>
>;
export type UpgradeAutomationConnectionsMutationBody =
  AutomationServiceUpgradeAutomationConnectionsBody;
export type UpgradeAutomationConnectionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary UpgradeAutomationConnections updates connection metadata (connection_id, endpoint)
without modifying the automation code. This is the most common operation for upgrading
from test to production credentials while keeping connection names unchanged.
 */
export const useUpgradeAutomationConnections = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upgradeAutomationConnections>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceUpgradeAutomationConnectionsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upgradeAutomationConnections>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceUpgradeAutomationConnectionsBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpgradeAutomationConnectionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ValidateAutomationPublish checks if an automation is ready to be published.
Returns information about missing credentials needed for publish.
Per AIP-136, this is a custom method using the :validatePublish suffix.
 */
export const validateAutomationPublish = (
  organization: string,
  workspace: string,
  automation: string,
  automationServiceValidateAutomationPublishBody: AutomationServiceValidateAutomationPublishBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ValidateAutomationPublishResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations/${automation}:validatePublish`,
    automationServiceValidateAutomationPublishBody,
    options,
  );
};

export const getValidateAutomationPublishMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateAutomationPublish>>,
    TError,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceValidateAutomationPublishBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateAutomationPublish>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceValidateAutomationPublishBody;
  },
  TContext
> => {
  const mutationKey = ['validateAutomationPublish'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateAutomationPublish>>,
    {
      organization: string;
      workspace: string;
      automation: string;
      data: AutomationServiceValidateAutomationPublishBody;
    }
  > = props => {
    const { organization, workspace, automation, data } = props ?? {};

    return validateAutomationPublish(
      organization,
      workspace,
      automation,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateAutomationPublishMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateAutomationPublish>>
>;
export type ValidateAutomationPublishMutationBody =
  AutomationServiceValidateAutomationPublishBody;
export type ValidateAutomationPublishMutationError = AxiosError<RpcStatus>;

/**
 * @summary ValidateAutomationPublish checks if an automation is ready to be published.
Returns information about missing credentials needed for publish.
Per AIP-136, this is a custom method using the :validatePublish suffix.
 */
export const useValidateAutomationPublish = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateAutomationPublish>>,
      TError,
      {
        organization: string;
        workspace: string;
        automation: string;
        data: AutomationServiceValidateAutomationPublishBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validateAutomationPublish>>,
  TError,
  {
    organization: string;
    workspace: string;
    automation: string;
    data: AutomationServiceValidateAutomationPublishBody;
  },
  TContext
> => {
  const mutationOptions = getValidateAutomationPublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary BatchGetAutomationNames retrieves display names for multiple automations in a single request.
Returns a lightweight response containing only the automation ID and display name for each
requested automation. Useful for UI scenarios where full automation details are not needed.
Per AIP-136, this is a custom method using the :batchGetNames suffix on the collection.
 */
export const batchGetAutomationNames = (
  organization: string,
  workspace: string,
  params: BatchGetAutomationNamesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchGetAutomationNamesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations:batchGetNames`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getBatchGetAutomationNamesQueryKey = (
  organization?: string,
  workspace?: string,
  params?: BatchGetAutomationNamesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations:batchGetNames`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBatchGetAutomationNamesQueryOptions = <
  TData = Awaited<ReturnType<typeof batchGetAutomationNames>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: BatchGetAutomationNamesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof batchGetAutomationNames>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBatchGetAutomationNamesQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof batchGetAutomationNames>>
  > = ({ signal }) =>
    batchGetAutomationNames(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof batchGetAutomationNames>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BatchGetAutomationNamesQueryResult = NonNullable<
  Awaited<ReturnType<typeof batchGetAutomationNames>>
>;
export type BatchGetAutomationNamesQueryError = AxiosError<RpcStatus>;

export function useBatchGetAutomationNames<
  TData = Awaited<ReturnType<typeof batchGetAutomationNames>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: BatchGetAutomationNamesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof batchGetAutomationNames>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof batchGetAutomationNames>>,
          TError,
          Awaited<ReturnType<typeof batchGetAutomationNames>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBatchGetAutomationNames<
  TData = Awaited<ReturnType<typeof batchGetAutomationNames>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: BatchGetAutomationNamesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof batchGetAutomationNames>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof batchGetAutomationNames>>,
          TError,
          Awaited<ReturnType<typeof batchGetAutomationNames>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBatchGetAutomationNames<
  TData = Awaited<ReturnType<typeof batchGetAutomationNames>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: BatchGetAutomationNamesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof batchGetAutomationNames>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary BatchGetAutomationNames retrieves display names for multiple automations in a single request.
Returns a lightweight response containing only the automation ID and display name for each
requested automation. Useful for UI scenarios where full automation details are not needed.
Per AIP-136, this is a custom method using the :batchGetNames suffix on the collection.
 */

export function useBatchGetAutomationNames<
  TData = Awaited<ReturnType<typeof batchGetAutomationNames>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: BatchGetAutomationNamesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof batchGetAutomationNames>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBatchGetAutomationNamesQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Each automation is processed independently: a failure on one automation does not
block the remaining automations. The automation version is incremented once per
successfully upgraded automation.

This operation only works on draft automations. To upgrade connections in a published
automation, first use ForkPublishedAutomation to create a draft, then call this method.

Per AIP-136, this is a custom method using the :bulkUpgradeBookConnections suffix.
 * @summary BulkUpgradeAutomationBookConnections upgrades all connections of a specific book
across multiple draft automations in a single request. The book is resolved from
the provided connection_id — every connection slot in each automation that belongs
to that book is replaced with the new connection, regardless of alias name.
 */
export const bulkUpgradeAutomationBookConnections = (
  organization: string,
  workspace: string,
  automationServiceBulkUpgradeAutomationBookConnectionsBody: AutomationServiceBulkUpgradeAutomationBookConnectionsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BulkUpgradeAutomationBookConnectionsResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations:bulkUpgradeBookConnections`,
    automationServiceBulkUpgradeAutomationBookConnectionsBody,
    options,
  );
};

export const getBulkUpgradeAutomationBookConnectionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpgradeAutomationBookConnections>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AutomationServiceBulkUpgradeAutomationBookConnectionsBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUpgradeAutomationBookConnections>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AutomationServiceBulkUpgradeAutomationBookConnectionsBody;
  },
  TContext
> => {
  const mutationKey = ['bulkUpgradeAutomationBookConnections'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUpgradeAutomationBookConnections>>,
    {
      organization: string;
      workspace: string;
      data: AutomationServiceBulkUpgradeAutomationBookConnectionsBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return bulkUpgradeAutomationBookConnections(
      organization,
      workspace,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUpgradeAutomationBookConnectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUpgradeAutomationBookConnections>>
>;
export type BulkUpgradeAutomationBookConnectionsMutationBody =
  AutomationServiceBulkUpgradeAutomationBookConnectionsBody;
export type BulkUpgradeAutomationBookConnectionsMutationError =
  AxiosError<RpcStatus>;

/**
 * @summary BulkUpgradeAutomationBookConnections upgrades all connections of a specific book
across multiple draft automations in a single request. The book is resolved from
the provided connection_id — every connection slot in each automation that belongs
to that book is replaced with the new connection, regardless of alias name.
 */
export const useBulkUpgradeAutomationBookConnections = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkUpgradeAutomationBookConnections>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AutomationServiceBulkUpgradeAutomationBookConnectionsBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkUpgradeAutomationBookConnections>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AutomationServiceBulkUpgradeAutomationBookConnectionsBody;
  },
  TContext
> => {
  const mutationOptions =
    getBulkUpgradeAutomationBookConnectionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary CountConnectionUsage returns the count of automations using each specified connection ID.
This is useful for understanding connection usage across automations before deletion or modification.
 */
export const countConnectionUsage = (
  organization: string,
  workspace: string,
  automationServiceCountConnectionUsageBody: AutomationServiceCountConnectionUsageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CountConnectionUsageResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations:countConnectionUsage`,
    automationServiceCountConnectionUsageBody,
    options,
  );
};

export const getCountConnectionUsageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof countConnectionUsage>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AutomationServiceCountConnectionUsageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof countConnectionUsage>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AutomationServiceCountConnectionUsageBody;
  },
  TContext
> => {
  const mutationKey = ['countConnectionUsage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof countConnectionUsage>>,
    {
      organization: string;
      workspace: string;
      data: AutomationServiceCountConnectionUsageBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return countConnectionUsage(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CountConnectionUsageMutationResult = NonNullable<
  Awaited<ReturnType<typeof countConnectionUsage>>
>;
export type CountConnectionUsageMutationBody =
  AutomationServiceCountConnectionUsageBody;
export type CountConnectionUsageMutationError = AxiosError<RpcStatus>;

/**
 * @summary CountConnectionUsage returns the count of automations using each specified connection ID.
This is useful for understanding connection usage across automations before deletion or modification.
 */
export const useCountConnectionUsage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof countConnectionUsage>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AutomationServiceCountConnectionUsageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof countConnectionUsage>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AutomationServiceCountConnectionUsageBody;
  },
  TContext
> => {
  const mutationOptions = getCountConnectionUsageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This API validates that the connection is not in use by any published
automations before deletion. If only draft automations use the connection,
deletion proceeds and returns the list of affected automations.

The affected draft automations will have unresolved connection references
after deletion. They can still be edited but cannot be published until
new connections are configured.

Errors:
- FAILED_PRECONDITION: Connection is in use by one or more published automations.
  The error details include DeleteConnectionBlockedError with blocking automations.
- NOT_FOUND: Connection not found in the workspace.
- INTERNAL: Failed to communicate with the connection storage service.
 * @summary DeleteWorkspaceConnection deletes a book connection from the workspace.
 */
export const deleteWorkspaceConnection = (
  organization: string,
  workspace: string,
  params: DeleteWorkspaceConnectionParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DeleteWorkspaceConnectionResponse>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations:deleteConnection`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteWorkspaceConnectionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkspaceConnection>>,
    TError,
    {
      organization: string;
      workspace: string;
      params: DeleteWorkspaceConnectionParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWorkspaceConnection>>,
  TError,
  {
    organization: string;
    workspace: string;
    params: DeleteWorkspaceConnectionParams;
  },
  TContext
> => {
  const mutationKey = ['deleteWorkspaceConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWorkspaceConnection>>,
    {
      organization: string;
      workspace: string;
      params: DeleteWorkspaceConnectionParams;
    }
  > = props => {
    const { organization, workspace, params } = props ?? {};

    return deleteWorkspaceConnection(
      organization,
      workspace,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWorkspaceConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWorkspaceConnection>>
>;

export type DeleteWorkspaceConnectionMutationError = AxiosError<RpcStatus>;

/**
 * @summary DeleteWorkspaceConnection deletes a book connection from the workspace.
 */
export const useDeleteWorkspaceConnection = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteWorkspaceConnection>>,
      TError,
      {
        organization: string;
        workspace: string;
        params: DeleteWorkspaceConnectionParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteWorkspaceConnection>>,
  TError,
  {
    organization: string;
    workspace: string;
    params: DeleteWorkspaceConnectionParams;
  },
  TContext
> => {
  const mutationOptions = getDeleteWorkspaceConnectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ListAutomationSummaries returns a paginated list of lightweight automation
summaries. Unlike ListAutomations, it omits heavy fields (code, artifacts,
full english_code text, etc.), making it well suited to list/grid views that
only need identifying and display metadata.
 */
export const listAutomationSummaries = (
  organization: string,
  workspace: string,
  params?: ListAutomationSummariesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListAutomationSummariesResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations:listSummaries`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListAutomationSummariesInfiniteQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListAutomationSummariesParams,
) => {
  return [
    'infinite',
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations:listSummaries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAutomationSummariesQueryKey = (
  organization?: string,
  workspace?: string,
  params?: ListAutomationSummariesParams,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations:listSummaries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAutomationSummariesInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAutomationSummaries>>,
    ListAutomationSummariesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationSummariesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAutomationSummaries>>,
        TError,
        TData,
        QueryKey,
        ListAutomationSummariesParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAutomationSummariesInfiniteQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAutomationSummaries>>,
    QueryKey,
    ListAutomationSummariesParams['page_token']
  > = ({ signal, pageParam }) =>
    listAutomationSummaries(
      organization,
      workspace,
      { ...params, page_token: pageParam || params?.['page_token'] },
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof listAutomationSummaries>>,
    TError,
    TData,
    QueryKey,
    ListAutomationSummariesParams['page_token']
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAutomationSummariesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAutomationSummaries>>
>;
export type ListAutomationSummariesInfiniteQueryError = AxiosError<RpcStatus>;

export function useListAutomationSummariesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAutomationSummaries>>,
    ListAutomationSummariesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListAutomationSummariesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAutomationSummaries>>,
        TError,
        TData,
        QueryKey,
        ListAutomationSummariesParams['page_token']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomationSummaries>>,
          TError,
          Awaited<ReturnType<typeof listAutomationSummaries>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationSummariesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAutomationSummaries>>,
    ListAutomationSummariesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationSummariesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAutomationSummaries>>,
        TError,
        TData,
        QueryKey,
        ListAutomationSummariesParams['page_token']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomationSummaries>>,
          TError,
          Awaited<ReturnType<typeof listAutomationSummaries>>,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationSummariesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAutomationSummaries>>,
    ListAutomationSummariesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationSummariesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAutomationSummaries>>,
        TError,
        TData,
        QueryKey,
        ListAutomationSummariesParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ListAutomationSummaries returns a paginated list of lightweight automation
summaries. Unlike ListAutomations, it omits heavy fields (code, artifacts,
full english_code text, etc.), making it well suited to list/grid views that
only need identifying and display metadata.
 */

export function useListAutomationSummariesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof listAutomationSummaries>>,
    ListAutomationSummariesParams['page_token']
  >,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationSummariesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof listAutomationSummaries>>,
        TError,
        TData,
        QueryKey,
        ListAutomationSummariesParams['page_token']
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAutomationSummariesInfiniteQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListAutomationSummariesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAutomationSummaries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationSummaries>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAutomationSummariesQueryKey(organization, workspace, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAutomationSummaries>>
  > = ({ signal }) =>
    listAutomationSummaries(organization, workspace, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAutomationSummaries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAutomationSummariesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAutomationSummaries>>
>;
export type ListAutomationSummariesQueryError = AxiosError<RpcStatus>;

export function useListAutomationSummaries<
  TData = Awaited<ReturnType<typeof listAutomationSummaries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params: undefined | ListAutomationSummariesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationSummaries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomationSummaries>>,
          TError,
          Awaited<ReturnType<typeof listAutomationSummaries>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationSummaries<
  TData = Awaited<ReturnType<typeof listAutomationSummaries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationSummaries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomationSummaries>>,
          TError,
          Awaited<ReturnType<typeof listAutomationSummaries>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListAutomationSummaries<
  TData = Awaited<ReturnType<typeof listAutomationSummaries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationSummaries>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary ListAutomationSummaries returns a paginated list of lightweight automation
summaries. Unlike ListAutomations, it omits heavy fields (code, artifacts,
full english_code text, etc.), making it well suited to list/grid views that
only need identifying and display metadata.
 */

export function useListAutomationSummaries<
  TData = Awaited<ReturnType<typeof listAutomationSummaries>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  params?: ListAutomationSummariesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAutomationSummaries>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListAutomationSummariesQueryOptions(
    organization,
    workspace,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary TraceConnectionUsage returns all automation IDs that use a specific connection.
This is useful for discovering which automations depend on a particular connection.
Per AIP-136, this is a custom method using the :traceConnectionUsage suffix.
 */
export const traceConnectionUsage = (
  organization: string,
  workspace: string,
  automationServiceTraceConnectionUsageBody: AutomationServiceTraceConnectionUsageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1TraceConnectionUsageResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/automations:traceConnectionUsage`,
    automationServiceTraceConnectionUsageBody,
    options,
  );
};

export const getTraceConnectionUsageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof traceConnectionUsage>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AutomationServiceTraceConnectionUsageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof traceConnectionUsage>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AutomationServiceTraceConnectionUsageBody;
  },
  TContext
> => {
  const mutationKey = ['traceConnectionUsage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof traceConnectionUsage>>,
    {
      organization: string;
      workspace: string;
      data: AutomationServiceTraceConnectionUsageBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return traceConnectionUsage(organization, workspace, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TraceConnectionUsageMutationResult = NonNullable<
  Awaited<ReturnType<typeof traceConnectionUsage>>
>;
export type TraceConnectionUsageMutationBody =
  AutomationServiceTraceConnectionUsageBody;
export type TraceConnectionUsageMutationError = AxiosError<RpcStatus>;

/**
 * @summary TraceConnectionUsage returns all automation IDs that use a specific connection.
This is useful for discovering which automations depend on a particular connection.
Per AIP-136, this is a custom method using the :traceConnectionUsage suffix.
 */
export const useTraceConnectionUsage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof traceConnectionUsage>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AutomationServiceTraceConnectionUsageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof traceConnectionUsage>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AutomationServiceTraceConnectionUsageBody;
  },
  TContext
> => {
  const mutationOptions = getTraceConnectionUsageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary TraceCollectionUsage returns all automations that use a specific collection,
along with how each one uses it (read or write). Usage is derived from the
collection access methods recorded in the automation's code manifest; any write
access classifies the collection as write.
Per AIP-136, this is a custom method using the :traceCollectionUsage suffix.
 */
export const traceCollectionUsage = (
  organization: string,
  workspace: string,
  collection: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1TraceCollectionUsageResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}:traceCollectionUsage`,
    options,
  );
};

export const getTraceCollectionUsageQueryKey = (
  organization?: string,
  workspace?: string,
  collection?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections/${collection}:traceCollectionUsage`,
  ] as const;
};

export const getTraceCollectionUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof traceCollectionUsage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof traceCollectionUsage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTraceCollectionUsageQueryKey(organization, workspace, collection);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof traceCollectionUsage>>
  > = ({ signal }) =>
    traceCollectionUsage(organization, workspace, collection, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && collection),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof traceCollectionUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraceCollectionUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof traceCollectionUsage>>
>;
export type TraceCollectionUsageQueryError = AxiosError<RpcStatus>;

export function useTraceCollectionUsage<
  TData = Awaited<ReturnType<typeof traceCollectionUsage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof traceCollectionUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof traceCollectionUsage>>,
          TError,
          Awaited<ReturnType<typeof traceCollectionUsage>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTraceCollectionUsage<
  TData = Awaited<ReturnType<typeof traceCollectionUsage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof traceCollectionUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof traceCollectionUsage>>,
          TError,
          Awaited<ReturnType<typeof traceCollectionUsage>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTraceCollectionUsage<
  TData = Awaited<ReturnType<typeof traceCollectionUsage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof traceCollectionUsage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary TraceCollectionUsage returns all automations that use a specific collection,
along with how each one uses it (read or write). Usage is derived from the
collection access methods recorded in the automation's code manifest; any write
access classifies the collection as write.
Per AIP-136, this is a custom method using the :traceCollectionUsage suffix.
 */

export function useTraceCollectionUsage<
  TData = Awaited<ReturnType<typeof traceCollectionUsage>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  collection: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof traceCollectionUsage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTraceCollectionUsageQueryOptions(
    organization,
    workspace,
    collection,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary BatchTraceCollectionUsage is TraceCollectionUsage for many collections at once,
so a list of collections can show usage without one call per collection.
 */
export const batchTraceCollectionUsage = (
  organization: string,
  workspace: string,
  automationServiceBatchTraceCollectionUsageBody: AutomationServiceBatchTraceCollectionUsageBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1BatchTraceCollectionUsageResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/collections:batchTraceCollectionUsage`,
    automationServiceBatchTraceCollectionUsageBody,
    options,
  );
};

export const getBatchTraceCollectionUsageMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchTraceCollectionUsage>>,
    TError,
    {
      organization: string;
      workspace: string;
      data: AutomationServiceBatchTraceCollectionUsageBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchTraceCollectionUsage>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AutomationServiceBatchTraceCollectionUsageBody;
  },
  TContext
> => {
  const mutationKey = ['batchTraceCollectionUsage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchTraceCollectionUsage>>,
    {
      organization: string;
      workspace: string;
      data: AutomationServiceBatchTraceCollectionUsageBody;
    }
  > = props => {
    const { organization, workspace, data } = props ?? {};

    return batchTraceCollectionUsage(
      organization,
      workspace,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchTraceCollectionUsageMutationResult = NonNullable<
  Awaited<ReturnType<typeof batchTraceCollectionUsage>>
>;
export type BatchTraceCollectionUsageMutationBody =
  AutomationServiceBatchTraceCollectionUsageBody;
export type BatchTraceCollectionUsageMutationError = AxiosError<RpcStatus>;

/**
 * @summary BatchTraceCollectionUsage is TraceCollectionUsage for many collections at once,
so a list of collections can show usage without one call per collection.
 */
export const useBatchTraceCollectionUsage = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchTraceCollectionUsage>>,
      TError,
      {
        organization: string;
        workspace: string;
        data: AutomationServiceBatchTraceCollectionUsageBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchTraceCollectionUsage>>,
  TError,
  {
    organization: string;
    workspace: string;
    data: AutomationServiceBatchTraceCollectionUsageBody;
  },
  TContext
> => {
  const mutationOptions = getBatchTraceCollectionUsageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary InvokeScheduledAutomation executes an automation triggered by its schedule.
Unlike InvokeAutomation, this method does not accept user-provided inputs or stage selection.
The automation always runs using the PUBLISHED stage with its configured default inputs.
This is an internal gRPC-only endpoint used by the scheduler service.
 */
export const invokeScheduledAutomation = (
  v1InvokeScheduledAutomationRequest: V1InvokeScheduledAutomationRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1InvokeScheduledAutomationResponse>> => {
  return axios.default.post(
    `/grimoire.v1.AutomationService/InvokeScheduledAutomation`,
    v1InvokeScheduledAutomationRequest,
    options,
  );
};

export const getInvokeScheduledAutomationMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invokeScheduledAutomation>>,
    TError,
    { data: V1InvokeScheduledAutomationRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invokeScheduledAutomation>>,
  TError,
  { data: V1InvokeScheduledAutomationRequest },
  TContext
> => {
  const mutationKey = ['invokeScheduledAutomation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invokeScheduledAutomation>>,
    { data: V1InvokeScheduledAutomationRequest }
  > = props => {
    const { data } = props ?? {};

    return invokeScheduledAutomation(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvokeScheduledAutomationMutationResult = NonNullable<
  Awaited<ReturnType<typeof invokeScheduledAutomation>>
>;
export type InvokeScheduledAutomationMutationBody =
  V1InvokeScheduledAutomationRequest;
export type InvokeScheduledAutomationMutationError = AxiosError<RpcStatus>;

/**
 * @summary InvokeScheduledAutomation executes an automation triggered by its schedule.
Unlike InvokeAutomation, this method does not accept user-provided inputs or stage selection.
The automation always runs using the PUBLISHED stage with its configured default inputs.
This is an internal gRPC-only endpoint used by the scheduler service.
 */
export const useInvokeScheduledAutomation = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof invokeScheduledAutomation>>,
      TError,
      { data: V1InvokeScheduledAutomationRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof invokeScheduledAutomation>>,
  TError,
  { data: V1InvokeScheduledAutomationRequest },
  TContext
> => {
  const mutationOptions = getInvokeScheduledAutomationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * This is an internal ops endpoint used for a one-time data migration. It is idempotent:
aliases already present in the connections map are not modified. Errors for individual
phases are captured in server logs and do not abort the migration.

The server processes all matching automations internally in batches of 10, logging
progress to the console after each batch. The caller receives a single summary
response once all automations have been processed.
 * @summary MigrateConnectionAliases backfills missing connection aliases into automation phases.
For each automation, it examines the latest draft and published phase code, extracts
all connection aliases via static analysis, and inserts any missing aliases with an
empty connection_id into the stored connections map.
 */
export const migrateConnectionAliases = (
  v1MigrateConnectionAliasesRequest: V1MigrateConnectionAliasesRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1MigrateConnectionAliasesResponse>> => {
  return axios.default.post(
    `/grimoire.v1.AutomationService/MigrateConnectionAliases`,
    v1MigrateConnectionAliasesRequest,
    options,
  );
};

export const getMigrateConnectionAliasesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof migrateConnectionAliases>>,
    TError,
    { data: V1MigrateConnectionAliasesRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof migrateConnectionAliases>>,
  TError,
  { data: V1MigrateConnectionAliasesRequest },
  TContext
> => {
  const mutationKey = ['migrateConnectionAliases'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof migrateConnectionAliases>>,
    { data: V1MigrateConnectionAliasesRequest }
  > = props => {
    const { data } = props ?? {};

    return migrateConnectionAliases(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MigrateConnectionAliasesMutationResult = NonNullable<
  Awaited<ReturnType<typeof migrateConnectionAliases>>
>;
export type MigrateConnectionAliasesMutationBody =
  V1MigrateConnectionAliasesRequest;
export type MigrateConnectionAliasesMutationError = AxiosError<RpcStatus>;

/**
 * @summary MigrateConnectionAliases backfills missing connection aliases into automation phases.
For each automation, it examines the latest draft and published phase code, extracts
all connection aliases via static analysis, and inserts any missing aliases with an
empty connection_id into the stored connections map.
 */
export const useMigrateConnectionAliases = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof migrateConnectionAliases>>,
      TError,
      { data: V1MigrateConnectionAliasesRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof migrateConnectionAliases>>,
  TError,
  { data: V1MigrateConnectionAliasesRequest },
  TContext
> => {
  const mutationOptions = getMigrateConnectionAliasesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
